import React from 'react';
import { toProperCase } from '../const/util';
import Image, { buildImage } from './Image';
import Grid, { buildGrid } from './Grid';
import Carousel, { buildCarousel } from './Carousel';
import { PortfolioData, ImageProps, GridProps, CarouselProps, Gallery } from '../interfaces';
import '../assets/styles/Portfolio.css';

export default class Dynamic extends React.Component<PortfolioData> {

	getImage(gallery: ImageProps, i: number, id: string) {
		return (
			<Image {...buildImage(gallery, i, id)} />
		)
	}

	getGrid(gallery: GridProps, i: number, id: string) {
		let children = buildGrid(gallery.paths, i, id, gallery);
		return (
			<Grid
				key={id + '.' + i.toString() + '.Grid'}
				paths={gallery.paths}
				photos={children}
				margin={gallery.margin || 2}
				enableLightbox={gallery.enableLightbox !== false}
				columns={3}
				direction={gallery.direction}
				targetRowHeight={gallery.height || 200}
				ratio={gallery.ratio}
				ratios={gallery.ratios}
				style={{
					maxWidth: window.innerWidth < 480 ? '100%' : gallery.maxWidth !== undefined ? gallery.maxWidth : '800px',
					width: '100%',
					...gallery.style
				}}
			/>
		);
	}

	getCarousel(gallery: CarouselProps, i: number, id: string) {
		let data = buildCarousel(gallery.paths, i, id);
		let d = document as any;
		return (
			<Carousel
				key={id + '.' + i.toString() + '.Carousel'}
				paths={gallery.paths}
				enableLightbox={true}
				infiniteLoop={true}
				useKeyboardArrows={true}
				showStatus={false}
				emulateTouch={true}
				axis={gallery.axis || 'horizontal'}
				autoPlay={gallery.autoPlay !== false}
				width={d.innerWidth > 480 && gallery.width ? gallery.width : '100%'}
				selectedItem={gallery.selectedItem || 0}
				showThumbs={gallery.showThumbs !== false}
				interval={gallery.interval || 4000}
				transitionTime={gallery.transitionTime || 500}
				centerMode={gallery.centerMode || false}
				dynamicHeight={gallery.dynamicHeight || false}
				photos={data}
				style={{
					maxWidth: window.innerWidth < 480 ? '100%' : Math.min(parseInt(gallery.maxWidth !== undefined ? gallery.maxWidth : '1200px'), 0.7 * window.innerWidth)
				}}
			>
				{data.map(props => {
					return (
						<div key={id + '.' + i.toString()}>
							<img
								{...props}
								alt={props.alt}
							></img>
						</div>
					)
				})}
			</Carousel>
		);
	}

	render() {
		let element = (
			<div className={'post portfolio-text'}>
				<h1>{this.props.title}</h1>
				<h2>{this.props.subtitle}</h2>
				{this.props.body}
				{(this.props.galleries || []).map((gallery: Gallery, i: number) => {
					try {
						if (!gallery.type) throw new Error('No type specified for gallery ' + gallery.id);
						let func = 'get' + toProperCase(gallery.type);
						return this[func as 'getImage' | 'getGrid' | 'getCarousel'](gallery as any, i, this.props.id);
					} catch (e) {
						if (e) console.error(e);
						return null;
					}
				})}
			</div>
		);
		return element;
	}

}